import React from "react";
import { Button, Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPen,
  faTrash,
  faEye,
  faEllipsis,
} from "../../../../../helpers/icons/fontAwesomeIcons";
import PropTypes from "prop-types";
import classes from "./MoreInfoButton.module.scss";

// Custom toggle component for the dropdown
const CustomToggle = React.forwardRef(({ onClick }, ref) => (
  <Button
    ref={ref}
    variant="link"
    className={classes.actionEllipsis}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    <FontAwesomeIcon icon={faEllipsis} />
  </Button>
));

const MoreInfoButton = ({
  t,
  row,
  onActionClick,
  actions = {
    view: true,
    edit: true,
    delete: true,
    custom: [],
  },
  stopPropagation = true,
}) => {
  const handleActionClick = (e, actionType) => {
    if (stopPropagation) {
      e.stopPropagation();
    }
    onActionClick(actionType, row);
  };

  return (
    <Dropdown>
      <Dropdown.Toggle as={CustomToggle} id={`dropdown-${row.id || "row"}`} />
      <Dropdown.Menu align="end" className={classes.actionsMenu}>
        {actions.view && (
          <Dropdown.Item onClick={(e) => handleActionClick(e, "view")}>
            <FontAwesomeIcon icon={faEye} className={classes.actionIcon} />
            {t("view")}
          </Dropdown.Item>
        )}

        {actions.edit && (
          <Dropdown.Item onClick={(e) => handleActionClick(e, "edit")}>
            <FontAwesomeIcon icon={faPen} className={classes.actionIcon} />
            {t("edit")}
          </Dropdown.Item>
        )}

        {actions.delete && (
          <Dropdown.Item
            onClick={(e) => handleActionClick(e, "delete")}
            className={classes.deleteAction}
          >
            <FontAwesomeIcon icon={faTrash} className={classes.actionIcon} />
            {t("delete")}
          </Dropdown.Item>
        )}

        {actions.custom &&
          actions.custom.map((action, index) => (
            <Dropdown.Item
              key={index}
              onClick={(e) => handleActionClick(e, action.key)}
            >
              <FontAwesomeIcon
                icon={action.icon}
                className={classes.actionIcon}
              />
              {action.label}
            </Dropdown.Item>
          ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

CustomToggle.propTypes = {
  onClick: PropTypes.func.isRequired,
};

MoreInfoButton.propTypes = {
  t: PropTypes.func.isRequired,
  row: PropTypes.object.isRequired,
  onActionClick: PropTypes.func.isRequired,
  actions: PropTypes.shape({
    view: PropTypes.bool,
    edit: PropTypes.bool,
    delete: PropTypes.bool,
    custom: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        icon: PropTypes.object.isRequired,
      })
    ),
  }),
  stopPropagation: PropTypes.bool,
};

export default MoreInfoButton;
